import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { BASE_API } from "../Config/Config";

const Management = () => {
    const { t, i18n } = useTranslation();

    const [members, setMembers] = useState([])

    const fetchmanagement = async (i) => {
        try {

            const res = await fetch(
                `${BASE_API}/apis/managementShow.php`,
                {
                    method: "POST",
                }
            );

            const result = await res.json();
            if (result.status === "success") {
                setMembers(result.data);
            } else {
                console.error("Failed to Update Management Team");
                setMembers([]);
            }
        } catch {
            console.error("Something Went Wrong");
            setMembers([]);
        }
    };

    useEffect(() => {
        fetchmanagement();
    }, []);

    return (
        <div className="container py-5">
            <h2 className="text-center fw-bold mb-4" data-aos="fade-down">
                {t('managementTeam')}
            </h2>

            <div className="row justify-content-center">
                {members.map((member, index) => (
                    <div className="col-md-3 mb-4" key={index}>
                        <div className="card shadow-sm text-center border-0 h-100">

                            <div
                                className="d-flex align-items-center justify-content-center bg-light mt-2 m-auto"
                                style={{
                                    width: "220px",
                                    height: "220px",
                                    border: "3px dashed #91c0ec",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    backgroundColor: "#91c0ec",
                                }}
                            >
                                <img
                                    src={`${BASE_API}/apis/uploads/${member.image}`}
                                    alt={i18n.language === "ta" ? member.ta_name : member.en_name}
                                    className="img-fluid rounded"
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "cover",
                                        padding: "5px",
                                    }}
                                />
                            </div>

                            {/* Card Body */}
                            <div className="card-body">
                                <h6 className="text-primary fw-semibold">
                                    {i18n.language === "ta" ? member.ta_name : member.en_name}
                                </h6>
                                <p className="small mt-2">
                                    {i18n.language === "ta" ? member.ta_role : member.en_role}
                                </p>
                            </div>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Management;